module.exports = __webpack_public_path__ + "assets/embedplus.fef461f0.svg";